<template>
  <div class="reports">
    <div v-if="this.loading" class="col-lg-9">
      <div class="d-flex justify-content-center">
        <div class="spinner-grow m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="container py-3">
        <div class="row">
          <div class="col-6"></div>
          <div class="col-6"></div>
        </div>
      </div>
      <div class="accordion pb-5">
        <div v-if="this.userData.role === 'administrator'">
          <div class="card" v-for="report in this.dailyReportList.results" :key="report.id">
            <div class="card-header" id="headingOne">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left"
                        @click="reportShow(report.id)"
                        type="button">
                  Автоматическая проверка подписок {{ fixDate(report.created_at) }}
                </button>
              </h2>
            </div>
            <div :id="report.id" class="collapse">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h6>Оплата подписки</h6>
                    <ul v-for="payed in report.data.payed" :key="payed.contract">
                      <li>Пользователь {{ payed.contract }} <br>
                        Сумма {{ payed.price }} <br>
                        Баланс {{ payed.balance }}
                      </li>
                    </ul>
                  </div>
                  <div class="col">
                    <h6>Деактивация</h6>
                    <ul v-for="deactivated in report.data.deactivated" :key="deactivated.contract">
                      <li>Подписчик: {{ deactivated.contract }} <br>
                        Сумма платежа: {{ deactivated.price }} <br>
                        Баланс подписчика: {{ deactivated.balance }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="this.userData.role === 'dealer'">
          <div class="card" v-for="report in this.dealerMonthReportList.results" :key="report.id">
            <div class="card-header" id="headingTwo">
              <h2 class="mb-0">
                <button class="btn btn-link btn-block text-left"
                        @click="reportShow(report.id)"
                        type="button">
                  Отчет за: {{ fixDate(report.created_at) }} || Всего платежей:
                  {{ report.data.count }} || На сумму: {{ report.data.total }} руб.
                </button>
              </h2>
            </div>
            <div :id="report.id" class="collapse">
              <div class="card-body">
                <div class="row">
                  <div class="col-2">
                    <h6>Дата</h6>
                  </div>
                  <div class="col-5">
                    <h6>Подписчик</h6>
                  </div>
                  <div class="col-3">
                    <h6>Тариф</h6>
                  </div>
                  <div class="col-2">
                    <h6>Комиссия</h6>
                  </div>
                </div>
                <div class="row" v-for="r in report.data.payments" :key="r.subscriber">
                  <div class="col-2">
                    <h6>{{ fixDate(r.date) }}</h6>
                  </div>
                  <div class="col-5">
                    <h6>{{ r.subscriber }}</h6>
                  </div>
                  <div class="col-3">
                    <h6>{{ r.tariff }}</h6>
                  </div>
                  <div class="col-2">
                    <h6>{{ r.fee }} руб.</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-paginator :data="this.reports" @change="pageCallback" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import VPaginator from '../../components/layouts/v-paginator.vue';

export default {
  name: 'Reports',
  components: { VPaginator },
  data() {
    return {
      loading: true,
      page: 1,
      fullReportFilter: '',
      reports: {},
    };
  },
  computed: {
    ...mapState('report', ['dailyReportList', 'dealerMonthReportList']),
    ...mapState('user', ['userData']),
  },
  methods: {
    ...mapActions('report', ['getDailyReportList', 'getDealerMonthReportList']),
    pageCallback(pageNum) {
      this.page = pageNum;
      this.getFilteredReports();
    },
    reportShow(id) {
      const el = document.getElementById(id);
      if (el.classList.contains('show')) {
        el.classList.remove('show');
      } else {
        el.classList.add('show');
      }
    },
    getFilteredReports() {
      this.fullReportFilter = `?without_blank=true&page=${this.page}`;
      if (this.userData.role === 'administrator') {
        this.getDailyReportList(this.fullReportFilter)
          .then(() => { this.reports = this.dailyReportList; })
          .then(() => { this.loading = false; });
      } else if (this.userData.role === 'dealer') {
        this.getDealerMonthReportList(this.fullReportFilter)
          .then(() => { this.reports = this.dealerMonthReportList; })
          .then(() => { this.loading = false; });
      }
    },
  },
  mounted() {
    this.getFilteredReports();
  },
};
</script>
